module.exports = __webpack_public_path__ + "assets/img/bg.e0700ac0.png";